// start turncate-content
document.addEventListener('DOMContentLoaded', function() {
if(document.getElementById('turncate-content')){
  document.getElementById('turncate-content').children[0].style.display = 'block';
  document.getElementById('turncate-content-less-btn').style.display = 'none';
  
  let nodeLnth = document.getElementById('turncate-content').children.length;
  for (let i = 1; i < nodeLnth; i++) {
    document.getElementById('turncate-content').children[i].style.display = 'none';
  }
  document.getElementById('turncate-content-more-btn').addEventListener('click', function02);
  function function02() {
    for (let i = 1; i < nodeLnth; i++) {
      document.getElementById('turncate-content').children[i].style.display = 'block';
    }
    document.getElementById('turncate-content-less-btn').style.display = 'block';
    document.getElementById('turncate-content-more-btn').style.display = 'none';
  };
  document.getElementById('turncate-content-less-btn').addEventListener('click', function03);
  
  function function03() {
    for (let i = 1; i < nodeLnth; i++) {
      document.getElementById('turncate-content').children[i].style.display = 'none';
    }
    document.getElementById('turncate-content-less-btn').style.display = 'none';
    document.getElementById('turncate-content-more-btn').style.display = 'block';
  };
  
  if (document.getElementById('turncate-content').children.length <= 1) {
    document.getElementById('turncate-content-less-btn').style.display = 'none';
    document.getElementById('turncate-content-more-btn').style.display = 'none';
  }
} 
else{
  if(document.getElementById('turncate-content-less-btn')){
    document.getElementById('turncate-content-less-btn').style.display = 'none';
    document.getElementById('turncate-content-more-btn').style.display = 'none';  
  }
}

// end turncate-content
// jQuery(document).ready(function($) {
    
  $(".sorting-collections__products").slick({
    infinite: true,
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 1,
       prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
       nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

let sliderImageExist = document.getElementsByClassName('product-detail-videos-slider')[0];
if(sliderImageExist != undefined){
  $('.product-detail-videos-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
  });
}
});

// $(document).ready(function() {
//     function initializeSlickSlider() {
//         $('.inner-subheader-element').slick({
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             dots: false,
//             arrows: false,
//         });
//     }

//     function toggleSlickSlider() {
//         if ($(window).width() < 900) {
//             if (!$('.inner-subheader-element').hasClass('slick-initialized')) {
//                 initializeSlickSlider();
//             }
//         } else {
//             if ($('.inner-subheader-element').hasClass('slick-initialized')) {
//                 $('.inner-subheader-element').slick('unslick');
//             }
//         }
//     }

//     toggleSlickSlider();

//     $(window).on('resize', function() {
//         toggleSlickSlider();
//     });
// });


// Dawn theme slider logic for `.inner-subheader-element` on mobile only
document.addEventListener('DOMContentLoaded', function() {
    const sliderGrid = document.querySelector('.inner-subheader-element');

    function initializeSlickSlider() {
        $(sliderGrid).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
          autoplay: true,
           speed: 1000,
        });
    }

    function toggleSlickSlider() {
        if (window.innerWidth < 900) {
            if (!$(sliderGrid).hasClass('slick-initialized')) {
                initializeSlickSlider();
            }
        } else {
            if ($(sliderGrid).hasClass('slick-initialized')) {
                $(sliderGrid).slick('unslick');
            }
        }
    }

    // Run on initial load
    toggleSlickSlider();

    // Run on resize
    window.addEventListener('resize', toggleSlickSlider);

    // For live editing in Shopify editor
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', toggleSlickSlider);
        document.addEventListener('shopify:section:unload', toggleSlickSlider);
    }
});
